import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from "@headlessui/react";
function WPQTSelect({ options, selectedOptionValue, onSelectionChange, allSelector = true, className = "", }) {
    const handleChange = (event) => {
        const selectedValue = event.target.value;
        onSelectionChange(selectedValue);
    };
    return (_jsxs(Select, { value: selectedOptionValue, onChange: handleChange, className: `!wpqt-rounded-lg !wpqt-border !wpqt-border-solid !wpqt-border-qtBorder !wpqt-px-2 !wpqt-pr-6 !wpqt-py-1 focus:wpqt-outline-none data-[focus]:wpqt-outline-2 data-[focus]:wpqt--outline-offset-2 data-[focus]:wpqt-outline-gray-300 ${className}`, children: [allSelector && _jsx("option", { value: "", children: "All boards" }), options.map((option) => (_jsx("option", { value: option.value, children: option.label }, option.value)))] }));
}
export { WPQTSelect };
